/** Los idiomas que la aplicación sabe nombrar, en ISO 639-2. Lo comparten el editor de
 *  pistas —que los ofrece en su desplegable— y el reproductor, que rotula con ellos cada
 *  pista de audio y de subtítulos. Una sola lista: dos copias es la forma de que una
 *  pantalla diga «español» y la otra `spa`. */
export const IDIOMAS = ['spa', 'eng', 'fra', 'deu', 'ita', 'por', 'cat', 'glg', 'eus', 'jpn', 'zho', 'rus'];

export const NOMBRES_IDIOMA: Record<string, string> = {
  spa: 'español', eng: 'inglés', fra: 'francés', deu: 'alemán', ita: 'italiano', por: 'portugués',
  cat: 'catalán', glg: 'gallego', eus: 'euskera', jpn: 'japonés', zho: 'chino', rus: 'ruso',
};

/** Lo que el desplegable escribe EN EL CAMPO, que no es lo mismo que un rótulo: MUI llama a
 *  esto para rellenar el input cada vez que cambia el valor, y lo que quede escrito vuelve
 *  por `onInputChange` como idioma de la pista. Por eso «sin idioma» aquí sería un desastre:
 *  una pista sin idioma se guardaba con el código literal `sin idioma`. Vacío, y el
 *  `placeholder` dice lo que hay que decir sin llegar a ser un valor. */
export function etiquetaIdioma(codigo: string | null): string {
  if (!codigo) return '';
  return NOMBRES_IDIOMA[codigo] ? `${NOMBRES_IDIOMA[codigo]} (${codigo})` : codigo;
}

/** Para rotular, no para rellenar un campo: aquí «sin idioma» sí es lo que hay que decir. */
export function nombreIdioma(codigo: string | null): string {
  if (!codigo) return 'sin idioma';
  return NOMBRES_IDIOMA[codigo] ?? codigo;
}
